import React, { useEffect, useState, useRef } from "react";
import { Col, Row, Card, CardText, Form, CardBody } from "reactstrap";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import readXlsxFile from "read-excel-file";
import ModeloUpload from "../../../assets/statics/modelo_agenda_cotas.xlsx";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
import {
  allExcelColumns,
  excelColumnsPtBr,
} from "./importScheduleQuotaValidation";
import ModalExcelRows from "../Voo/ModalExcelRows";
import moment from "moment";
import { importScheduleQuota } from "../../../utils/services/scheduleCotas";

const SCHEDULE_QUOTAS_SCHEMA = {
  Titulo: { prop: "title", type: String },
  DataDaProgramacao: { prop: "startDate", type: Date },
  HoraInicio: { prop: "startHour", type: String },
  HoraFim: { prop: "endHour", type: String },
  QuantidadeCotas: { prop: "qtdCotas", type: Number },
  CotasFechadas: { prop: "cotasFechadas", type: Number },
  CotasSorteio: { prop: "cotasSorteio", type: Number },
  Grupos: { prop: "groups", type: String },
};

function isEqual(a, b) {
  if (a.length !== b.length) return false;
  return (
    a.every((item) => b.includes(item)) && b.every((item) => a.includes(item))
  );
}

export default function ImportScheduleQuotas(props) {
  const { isOpen, toggle, idEvent } = props;

  // state de dados
  const [selectedFiles, setselectedFiles] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  const importActivated = useRef(false);

  // state de UI
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [imgError, setImgError] = useState("");
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);

  // state de erros no arquivo xlsx
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    setselectedFiles([]);
    setImgError("");
  }, [isOpen]);

  // prepara o arquivo selecionado para exibição e habilita o envio
  function handleAcceptedFiles(files) {
    files.forEach((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  // cancela o processo de importação em andamento
  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;
    setBtnSend(false);
    setBtnCancel(true);

    let count = 0;

    const readXlsx = async () => {
      const { rows } = await readXlsxFile(selectedFiles[0], {
        schema: SCHEDULE_QUOTAS_SCHEMA,
      });
      const validateRows = rows.map((row, i) => allExcelColumns(row, i));

      setTotalRows(validateRows.length);

      const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
      const header = rowsWithoutSchema[0];
      const schemaColumns = Object.keys(SCHEDULE_QUOTAS_SCHEMA);

      if (!isEqual(schemaColumns, header)) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      const rowsWithError = validateRows.filter(
        (row) =>
          Object.values(row).filter((value) => value === undefined).length > 0,
      );

      if (rowsWithError.length > 0 || rows.length === 0) {
        setErrors(rowsWithError);
        setModalErrors(true);
      } else {
        for (const row of validateRows) {
          if (importActivated.current) {
            await importScheduleService(row, validateRows.length);
          }
        }
      }
    };

    await readXlsx();

    async function importScheduleService(row, total) {
      await importScheduleQuota({
        eventId: idEvent,
        startDate: moment(row.startDate)
          .format()
          .replace("00:00:00-03:00", "00:01"),
        startHour: row.startHour,
        endHour: row.endHour,
        title: row.title,
        qtdCotas: row.qtdCotas,
        cotasFechadas: row.cotasFechadas,
        cotasSorteio: row.cotasSorteio,
        groups: row.groups,
      })
        .then((e) => {
          count++;
          if (e.message === "created") {
            setTotalSended(count);
          }
          if (count === total) {
            setsuccess_dlg(true);
          }
        })
        .catch((error) => {
          setBtnCancel(false);
          setImgError("Erro ao enviar o arquivo. Tente novamente.");
          console.log(error);
        });
    }
  }

  return (
    <div>
      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            toggle();
            setsuccess_dlg(false);
          }}
        >
          {"O arquivo foi enviado com sucesso!"}
        </SweetAlert>
      ) : null}
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBr}
        />
      )}
      <div className="m-1 p-0">
        <Card className="p-1">
          <CardBody className="m-1 p-2">
            <CardText className="mb-2 p-10">
              O arquivo a ser importado deve seguir este{" "}
              <a href={ModeloUpload} download="modelo_agenda_cotas.xlsx">
                Modelo
              </a>
              , não modifique seu cabeçalho.
            </CardText>

            <Form>
              {selectedFiles.length === 0 && (
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles);
                  }}
                  maxFiles={1}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-1"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-4">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                          <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                        </div>
                      </div>
                    </div>
                  )}
                </Dropzone>
              )}
              <div className="dropzone-previews mt-0" id="file-previews">
                {selectedFiles.map((f, i) => {
                  return (
                    <Card
                      className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                      key={i + "-file"}
                    >
                      <div className="p-1">
                        <Row className="align-items-center">
                          <Col xs="11">
                            <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                          </Col>
                          <Col xs="1">
                            <span
                              style={{
                                fontSize: "16px",
                                color: "red",
                                fontWeight: "700",
                              }}
                              className="mdi mdi-close"
                              onClick={() => setselectedFiles([])}
                            />
                          </Col>
                        </Row>
                        {importActivated.current && (
                          <Row className="align-items-center">
                            <Col>
                              <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </Card>
                  );
                })}
              </div>
            </Form>

            <div className="text-center mt-3">
              <p style={{ color: "red" }}>{imgError}</p>
              <button
                type="button"
                disabled={!btnSend}
                className="btn btn-primary waves-effect waves-light"
                onClick={() => uploadService()}
              >
                Enviar Programação
              </button>
              <button
                type="button"
                className="btn btn-danger mx-1"
                disabled={!btnCancel}
                onClick={() => cancelImport()}
              >
                Cancelar
              </button>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
